<template>
  <v-dialog v-model="dialog" persistent width="780px">
    <v-card>
      <v-card-title class="headline">
        <v-icon>check</v-icon> Aprobar papeleta con cargo a vacación
        <v-spacer></v-spacer>
        <v-btn icon @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="py-0">
        <v-container grid-list-md class="pa-0" style="min-width: 100%;">
          <v-layout row wrap>
            <v-flex xs12>
              <h3 class="texto">
                <strong>Número:</strong> {{ permiso.numero }}
              </h3>
            </v-flex>
            <v-flex xs12>
              <h3 class="texto">
                <strong>Funcionario:</strong> {{ permiso.nombres }}
              </h3>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12>
              <h3 class="subtitulo-uso">
                <strong>Detalle de vacación </strong>
              </h3>
            </v-flex>
          </v-layout>

          <v-layout>
            <v-flex xs12>
              <v-data-table
                class="elevation-1 tabla-comprimida-light celda-comprimida"
                :items="permiso_detalles"
                hide-actions
                :headers="headers"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_desde }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.fecha_hasta }}
                  </td>
                  <td class="text-xs-center">{{ props.item.hora_desde }}</td>
                  <td class="text-xs-center">{{ props.item.hora_hasta }}</td>
                  <!-- <td v-if="props.item.rango_horario == 1">Solo mañana</td>
                  <td v-if="props.item.rango_horario == 2">Solo tarde</td>
                  <td v-if="props.item.rango_horario == 0">Todo el día</td> -->
                  <td class="text-xs-center">{{ props.item.dias }}</td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>

          <v-flex xs12>
            <h3 class="subtitulo-uso">
              <strong>Seguimiento solicitud con cargo a vacación</strong>
            </h3>
          </v-flex>
          <v-layout>
            <v-flex xs12>
              <v-data-table
                class="elevation-1 tabla-comprimida-light celda-comprimida"
                :headers="headers_seg_detalle"
                :items="detalle_seguimiento"
                hide-actions
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_registro }}
                  </td>
                  <td class="text-xs-center">
                    {{
                      props.item.estado ==
                      "Aprobado. Inmediato Superior Jerárquico"
                        ? "Aprobado"
                        : props.item.estado
                    }}
                  </td>
                  <td class="text-xs-center">{{ props.item.usuario }}</td>
                  <td class="text-xs-center">{{ props.item.jefe }}</td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secundary" @click.prevent="close()" :loading="loading"
          ><v-icon>close</v-icon>
          Cancelar
        </v-btn>
        <v-btn
          color="success"
          @click.prevent="apruebaPermiso(permiso)"
          :loading="loading"
          ><v-icon>check</v-icon>
          Aprobar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate";
//import SeguimientoDetalle from "../components/SeguimientoDetalle";

export default {
  components: {
    // SeguimientoDetalle
  },
  mixins: [validate],
  props: ["item"],
  async mounted() {
    this.$bus.$on("openDialogAprobarPermisoCtaVacacionJefeI", item => {
      this.permiso = item;
      console.log('this.permiso...',this.permiso);
      this.permiso.motivo_rechazo = "";
      this.getDetallePermiso();
      this.getDetalleSeguimiento(parseInt(this.permiso.id_vacacion));
      this.dialog = true;
      this.total_horas();
    });
  },
  data() {
    return {
      dialog: false,
      permiso: {
        motivo_rechazo: ""
      },
      permiso_detalles2: [],
      permiso_compensacion: [],
      permiso_detalles: [],
      detalle_seguimiento: [],
      loading: false,
      horas_solicitadas_comp: 0,
      total_horas_acomuladas: 0,
      headers: [
        {
          text: "Fecha desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        },
        // {
        //   text: "Total Horas",
        //   sortable: false,
        //   align: "center"
        // },
        {
          text: "Total Dias",
          sortable: false,
          align: "center"
        }
      ],

      headers2: [
        {
          text: "Fecha desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Total Horas",
          sortable: false,
          align: "center"
        }
      ],
      headers_seg_detalle: [
        // { text: 'Número', sortable: false, align: 'center'},
        { text: "Fecha de registro", sortable: false, align: "center" },
        { text: "Estado", sortable: false, align: "center" },
        { text: "Usuario ", sortable: false, align: "center" },
        { text: "Solicitud enviada a :", sortable: false, align: "center" }
      ],

      horas_solicitadas: 0
    };
  },
  methods: {
    // Envia correo al detinatario del permiso
    async enviarCorreoDestinatario(permiso) {
      let destinatario = await this.$service.obtieneDestinatarioPermiso(
        permiso.id_vacacion
      );
      if (!destinatario) {
        return;
      }
      destinatario = JSON.parse(destinatario);
      var mensaje = "";
      var asunto = "";
      // Verificamos si se esta aprobando
      if (destinatario.id_persona == permiso.id_funcionario) {
        mensaje = `
            <h1>NOTIFICACIÓN APROBACIÓN DE PERMISO</h1>
            Estimado(a): ${destinatario.nombres}<br>El motivo de la presente es para informarle que se le APROBO un permiso con los siguientes datos:<br>
            <b>NOMBRE SOLICITANTE:</b>  <br>${permiso.nombres}<br>
            <b>TIPO DE PERMISO:</b>  <br>${permiso.tipo_permiso}<br>
            <b>NRO PAPELETA:</b>  <br>${permiso.numero}<br>
            <b>FECHA DE SOLICITUD:</b>  <br>${permiso.fecha_emision}<br>
            <b>FECHA SALIDA - FIN:</b>  <br>${permiso.fecha_desde} - ${permiso.fecha_retorno}<br>
            <b>HORAS:</b>  <br>${permiso.hora_desde} - ${permiso.hora_hasta}<br>
            <br>
            Saludos cordiales.`;
        asunto = "NOTIFICACIÓN APROBACIÓN DE PERMISO";
      } else {
        mensaje = `
            <h1>NOTIFICACIÓN SOLICITUD DE PERMISO</h1>
            Estimado(a): ${destinatario.nombres}<br>El motivo de la presente es para informarle que se le envio una solicitud de permiso con los siguientes datos:<br>
            <b>NOMBRE SOLICITANTE:</b>  <br>${permiso.nombres}<br>
            <b>TIPO DE PERMISO:</b>  <br>${permiso.tipo_permiso}<br>
            <b>NRO PAPELETA:</b>  <br>${permiso.numero}<br>
            <b>FECHA DE SOLICITUD:</b>  <br>${permiso.fecha_emision}<br>
            <b>FECHA SALIDA - FIN:</b>  <br>${permiso.fecha_desde} - ${permiso.fecha_retorno}<br>
            <b>HORAS:</b>  <br>${permiso.hora_desde} - ${permiso.hora_hasta}<br>
            <br>
            Ingrese al sistema para APROBAR o RECHAZAR EL PERMISO <br>
            Saludos cordiales.`;
        asunto = "NOTIFICACIÓN SOLICITUD DE PERMISO";
      }
      await this.$service.sendEmail({
        correo: destinatario.correo,
        asunto: asunto,
        mensaje: mensaje.replace(/<[^>]+>/g, ""),
        html: mensaje
      });
    },

    async total_horas() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
                query{
                  runQuery(consulta:"select control.fn_total_horas_compensacion(${this.permiso.id_vacacion})"){
                    respuesta
                  }
                }	

              `
        });
        if (
          respuesta.runQuery.respuesta[0].fn_total_horas_compensacion == null ||
          respuesta.runQuery.respuesta[0].fn_total_horas_compensacion ==
            undefined
        ) {
          this.total_horas_acomuladas = 0;
        } else {
        }
        let resp = respuesta.runQuery.respuesta[0].fn_total_horas_compensacion;
        this.total_horas_acomuladas = resp;
      } catch (error) {
        console.log(error);
      }
    },

    close() {
      this.dialog = false;
      this.permiso = {
        motivo: ""
      };
      this.$bus.$emit("closeDialogAprobarPapJefeI");
    },

    sumar_horas(permiso_detalles) {
      let total = 0;
      permiso_detalles.forEach(item => {
        total +=
          this.$moment(item.fecha_hasta + " " + item.hora_hasta).diff(
            item.fecha_desde + " " + item.hora_desde,
            "minutes"
          ) / 60;
      });
      this.horas_solicitadas = total;
    },
    getUserId() {
      const user = this.$storage.get("user");
      return user.id_persona;
    },
    getDetallePermiso() {
      this.permiso_detalles = [
        {
          fecha_desde: this.permiso.fecha_desde,
          fecha_hasta: this.permiso.fecha_hasta,
          hora_desde: this.permiso.hora_desde,
          hora_hasta: this.permiso.hora_hasta,
          dias: this.permiso.dias
        }
      ];
    },
    async getDetalleSeguimiento(id) {
      try {
        let respuesta = [];
        let res = [];
        respuesta = await this.$service.graphql({
          query: `
                               query{
                                    runQuery(consulta:"SELECT * FROM control.v_seguimiento_detalle_historico vd where vd.id=(${id}) order by vd.id_seguimiento desc"){
                                  respuesta
                                }
                            }
                            `
        });
        if (respuesta.runQuery.respuesta.length > 0) {
          respuesta = respuesta.runQuery.respuesta;
        }
        //obtener el nuevo seguimiento
        res = await this.$service.graphql({
          query: `
                query{
      			      vSeguimientoDetalles(id:${id}){
          			    rows{
						          fecha_registro
            			    estado
            			    usuario
                      jefe
                      id_estado
                      motivo
                      jefe
                      }
                  }
              }

          `
        });
        if (res.vSeguimientoDetalles.rows.length > 0) {
          res = res.vSeguimientoDetalles.rows;
        }

        this.detalle_seguimiento = res.concat(respuesta);
      } catch (error) {
        console.log(error);
      }
    },
    async apruebaPermiso(permiso) {
      this.loading = true;
      let id_estado;
      const user = this.$storage.get("user");
      let respuesta = "";
      // const permiso_copia = JSON.parse(JSON.stringify(this.permiso));
      // permiso_copia.hora_desde = this.permiso_detalles2[0].hora_desde;
      // permiso_copia.hora_hasta = this.permiso_detalles2[0].hora_hasta;
      try {
        if (this.permiso.nivel_jefe == 2) {
          //aprobar inmediato
          id_estado = 7;
          respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select control.fn_aprueba_cta_vacacion(${permiso.id_vacacion},${id_estado},${user.id_persona},${user.id})"){
                  respuesta
                }
              }
            `
          });
          console.log('select control.fn_aprueba_cta_vacacion',permiso.id_vacacion,id_estado,user.id_persona,user.id);
          
          let resp = respuesta.runQuery.respuesta[0].fn_aprueba_cta_vacacion;
          let resps = resp.split("|");
          let correcto = resps[0];
          if (correcto == "1") {
            this.$confirm("El permiso fué aprobado", () => {});
            this.close();
          } else {
            this.$confirm(resps[1], () => {});
            this.close();
          }
          this.loading = false;
        } else {
          //aprobar jerarquico
          id_estado = 75;

          respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select control.fn_aprueba_cta_vacacion_jerarquico(${permiso.id_vacacion},${id_estado},${user.id_persona},${user.id})"){
                  respuesta
                }
              }
            `
          });
          let resp =
            respuesta.runQuery.respuesta[0].fn_aprueba_cta_vacacion_jerarquico;
          let resps = resp.split("|");
          let correcto = resps[0];
          if (correcto == "1") {
            this.$confirm("La papeleta fué aprobada", () => {});
            this.close();
          } else {
            this.$confirm(resps[1], () => {});
            this.close();
          }
          this.loading = false;
        }
      } catch (error) {
        console.log(error);
      }
      // ENVIO DE CORREO
      //await this.enviarCorreoDestinatario(permiso_copia);
      this.loading = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.titulo {
  font-size: 1.07em;
  color: rgb(0, 77, 128);
  font-weight: bold;
  margin: 0 !important;
}
.texto {
  font-size: 1.07em;
  color: rgb(0, 50, 83);
  margin: 0 !important;
}
.subtitulo-uso {
  font-size: 1.35em;
  color: rgb(0, 77, 128);
  font-weight: bolder;
  margin: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/vacacion_uso/dialogs/AprobarPermiso.vue